module.exports = __webpack_public_path__ + "static/media/ig15.ce00dd28.jpg";